/**
 * Contratos das integrações.
 *
 * ⚠️ `DestinoPublico` é o que o servidor devolve — a config vem **sem os
 * segredos**. Um campo de senha preenchido aqui significaria que o segredo
 * atravessou a fronteira; ele nunca deve.
 */
export type TipoDestino = 'kace_ticket' | 'jira' | 'webhook' | 'email' | 'teams';

export interface DestinoPublico {
  readonly id: string;
  readonly nome: string;
  readonly tipo: TipoDestino;
  readonly ativo: boolean;
  readonly config: Record<string, unknown>;
  readonly segredoDefinido: boolean;
}

export interface Entrega {
  readonly id: number;
  readonly destinoId: string;
  readonly tipoEvento: string;
  readonly severidade: string;
  readonly estado: string;
  readonly tentativas: number;
  readonly referenciaExterna: string | null;
  readonly erro: string | null;
  readonly criadaEm: string;
  readonly payload: { readonly titulo?: string };
}

export interface RespostaDestinos {
  readonly itens: readonly DestinoPublico[];
  readonly resumoEntregas: readonly { readonly estado: string; readonly total: number }[];
}

export interface ConfigCatalogo {
  readonly configuracao: {
    readonly catalogo: {
      readonly softwareNaoPermitido: readonly string[];
      readonly softwareTolerado: readonly string[];
    };
  };
}

export const ROTULO_TIPO: Record<TipoDestino, string> = {
  kace_ticket: 'Chamado no KACE',
  jira: 'Jira',
  webhook: 'Webhook',
  email: 'E-mail',
  teams: 'Microsoft Teams',
};

/**
 * Tipos de evento oferecidos na tela.
 *
 * ⚠️ Espelha `TIPOS_DE_EVENTO` de `packages/domain/src/integracao/destino.ts`.
 * O front não depende do pacote de domínio — o servidor descarta o que não
 * conhece, então um tipo desatualizado aqui vira "sem efeito", nunca erro.
 */
export const TIPOS_DE_EVENTO: readonly {
  readonly valor: string;
  readonly rotulo: string;
  readonly grupo: string;
}[] = [
  { valor: 'violacao_detectada', rotulo: 'Violação de conformidade', grupo: 'Parque' },
  { valor: 'software_nao_permitido', rotulo: 'Software não permitido', grupo: 'Parque' },
  { valor: 'dispositivo_obsoleto', rotulo: 'Dispositivo obsoleto', grupo: 'Parque' },
  { valor: 'remediacao_concluida', rotulo: 'Remediação concluída', grupo: 'Parque' },
  { valor: 'remediacao_interrompida', rotulo: 'Remediação interrompida', grupo: 'Parque' },
  { valor: 'sla_em_risco', rotulo: 'Chamado prestes a vencer', grupo: 'Operação' },
  { valor: 'chamado_sem_responsavel', rotulo: 'Chamado sem responsável', grupo: 'Operação' },
  { valor: 'chamado_parado', rotulo: 'Chamado parado', grupo: 'Operação' },
  { valor: 'patch_critico_pendente', rotulo: 'Patch crítico pendente', grupo: 'Parque' },
];
